import { getOfficeHoursStartTime } from 'conversations-internal-schema/availability/operators/availabilityGetters';
import { OFFICE_HOURS } from 'conversations-message-history/office-hours-message/constants/messageTypes';
import { getOfficeHoursStartTimeFromMessageMetadata } from './getOfficeHoursStartTimeFromMessageMetadata';
export const isDuringOfficeHours = message => {
  const startTime = message['@type'] === OFFICE_HOURS ? getOfficeHoursStartTime(message) : getOfficeHoursStartTimeFromMessageMetadata(message);
  return typeof startTime === 'number' && startTime - new Date().getTime() < 0;
};